import { useState } from 'react';

export interface SelectOption {
  label: string;

  value: string;
}

export interface SelectProps {
  value?: string;

  options: SelectOption[];

  onSelect: (value: string) => void;
}

const Select = ({ value, options, onSelect }: SelectProps) => {
  const [selectedOption, setSelectedOption] = useState(value);

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedOption(value);
    onSelect(value);
  };

  return (
    <select
      className='block w-full py-1 px-3 border border-base-300 bg-base-400 shadow-sm focus:outline-none focus:ring-accent focus:border-accent'
      value={selectedOption}
      onChange={handleSelectChange}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Select;
